import React from "react";
import { BrowserRouter, Route, Routes as Switch, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Layout from "../components/Layout/Layout";
import Teacher from '../pages/Teacher/Teacher'
import Auth from '../pages/Auth/Auth'
import Expert from '../pages/Expert/Expert'
import Request from '../pages/Request'
import SharedFiles from '../pages/SharedFiles/SharedFiles'
import Constructor from "../pages/Constructor";

export const PATHS = {
    ROOT: '/',
    AUTH: {
      TEACHER: `/teacher`,
      EXPERT: `/expert`,
      GUK: `/guk`,
      REQUEST: `/request/:requestId`,
      SHARED_FILES: `/shared_files`,
      CONSTRUCTOR: `/constructor`,
    },
  };

const pageVariants = {
  initial: {
    opacity: 0,
    scale: 0.98,
  },
  animate: {
    opacity: 1,
    scale: 1,
  },
  exit: {
    opacity: 0,
    scale: 0.98,
  },
};

const pageTransition = {
  type: "tween",
  ease: "easeInOut",
  duration: 0.25,
};

const AnimatedPage = ({ children }) => (
  <motion.div
    initial="initial"
    animate="animate"
    exit="exit"
    variants={pageVariants}
    transition={pageTransition}
  >
    {children}
  </motion.div>
);

function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Switch location={location} key={location.pathname}>
        <Route exact path={PATHS.ROOT} element={<AnimatedPage><Auth/></AnimatedPage>} />
        <Route exact path={PATHS.AUTH.TEACHER} element={<AnimatedPage><Teacher/></AnimatedPage>} />
        <Route exact path={PATHS.AUTH.EXPERT} element={<AnimatedPage><Expert/></AnimatedPage>} />
        <Route exact path={PATHS.AUTH.GUK} element={<AnimatedPage><Expert/></AnimatedPage>} />
        <Route exact path={PATHS.AUTH.REQUEST} element={<AnimatedPage><Request/></AnimatedPage>} />
        <Route exact path={PATHS.AUTH.SHARED_FILES} element={<AnimatedPage><SharedFiles/></AnimatedPage>} />
        <Route exact path={PATHS.AUTH.CONSTRUCTOR} element={<AnimatedPage><Constructor/></AnimatedPage>} />
      </Switch>
    </AnimatePresence>
  );
}
  
export default function Routes() {
  return (
    <BrowserRouter>
      <Layout>
        <AnimatedRoutes />
      </Layout>
    </BrowserRouter>
  );
}